module.exports = __webpack_public_path__ + "assets/img/1.d0e3b5f2.png";